import mixpanel from 'mixpanel-browser';

export const Mixpanel = mixpanel;
